module.exports = __webpack_public_path__ + "img/baiyunshan.6471af4a.png";